<template>
  <div class="khlb-container">
    <el-row class="tcf-row">
      <el-col class="card">
        <div class="card-body">
          <div class="card-title">
            客户列表
            <el-button size="small" icon="el-icon-setting" style="margin-left: 70px" type="text" @click="groupDrawer = true">分组管理</el-button>
            <div class="search-mode">
              <input v-model="search" type="text" class="search-input" placeholder="关键字搜索" @keyup.enter="Search">
              <el-button class="search-btn" icon="el-icon-search" @click="Search" />
              <el-button class="add-btn" icon="el-icon-plus" type="primary" @click="addClient">添加客户</el-button>
            </div>
          </div>
          <div class="card-content">
            <el-row>
              <el-col :span="5">
                <ul class="group-filter">
                  <li v-for="gitem in groupOptions" :class="groupid===gitem.groupid?'active':''" @click="change(gitem.groupid)">{{ gitem.name }}</li>
                </ul>
              </el-col>
              <el-col v-loading="loading" :span="19">
                <el-table
                  :data="tableData"
                  :show-header="false"
                  :row-style="{cursor: 'pointer'}"
                  style="width: 100%"
                  @row-click="openDetails"
                >
                  <el-table-column
                    label="客户名称"
                    width="120"
                    show-overflow-tooltip
                  >
                    <template slot-scope="scope">
                      <span style="color:#000;margin-right: 10px">{{ scope.row.name }}</span>
                      <svg-icon v-if="scope.row.sex === 1" icon-class="client_man" class="client-sex" />
                      <svg-icon v-if="scope.row.sex === 0" icon-class="client_women" class="client-sex" />
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="联系电话"
                    width="140"
                    show-overflow-tooltip
                  >
                    <template slot-scope="scope">
                      <span>{{ scope.row.tel }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="客户地区"
                    width="200"
                    show-overflow-tooltip
                  >
                    <template slot-scope="scope">
                      <span>{{ scope.row.province }} {{ scope.row.city }} {{ scope.row.county }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="客户状态/标签"
                    show-overflow-tooltip
                  >
                    <template slot-scope="scope">
                      <el-tag v-if="scope.row.isgoto==1 && scope.row.status!=2" :disable-transitions="true" size="mini">已到店</el-tag>
                      <el-tag v-if="scope.row.isgoto==0 && scope.row.status!=2" type="danger" :disable-transitions="true" size="mini">未到店</el-tag>
                      <el-tag v-if="scope.row.status==2" size="mini" :disable-transitions="true">已签约</el-tag>
                      <el-tag v-for="(tag,index) in scope.row.tagList" v-if="scope.row.status!=2" :disable-transitions="true" :type="index==0?'success':index==1?'warning':''" size="mini" style="margin-right: 4px">{{ tag.name }}</el-tag>
                    </template>
                  </el-table-column>
                </el-table>
                <el-pagination
                  v-if="total>0"
                  background
                  :current-page="currentPage"
                  :page-sizes="[20, 50, 100]"
                  :page-size="pageSize"
                  layout="total, sizes, prev, pager, next, jumper"
                  :total="total"
                  @size-change="handleSizeChange"
                  @current-change="handleCurrentChange"
                />
              </el-col>
            </el-row>
          </div>
        </div>
      </el-col>
    </el-row>
    <el-drawer
      title="分组管理"
      :visible.sync="groupDrawer"
      direction="rtl"
    >
      <div class="group-container">
        <el-row>
          <div v-for="t in groupOptions" v-if="t.groupid > 3" class="group-item">
            <span>{{ t.name }}</span>
            <el-button v-if="t.userid != 0" type="danger" class="group-del" icon="el-icon-close" circle @click="delGroup(t.groupid)" />
          </div>
          <el-button size="small" icon="el-icon-plus" type="primary" plain @click="addGroup">添加分组</el-button>
        </el-row>
      </div>
    </el-drawer>
    <el-dialog
      title="添加客户"
      :visible.sync="dialogVisible"
      width="40%"
      top="10vh"
      :destroy-on-close="true"
      :lock-scroll="true"
      :append-to-body="true"
    >
      <el-form ref="infoForm" :model="infoForm" :rules="infoRules" label-position="right" label-width="75px" size="small">
        <el-form-item label="姓名" prop="name">
          <el-input v-model="infoForm.name" maxlength="5" />
        </el-form-item>
        <el-form-item label="电话" prop="tel">
          <el-input v-model="infoForm.tel" maxlength="11" minlength="11" />
        </el-form-item>
        <el-form-item label="微信" prop="weixin">
          <el-input v-model="infoForm.weixin" maxlength="20" />
        </el-form-item>
        <el-form-item label="性别" prop="sex">
          <el-radio-group v-model="infoForm.sex">
            <el-radio :label="2">未知</el-radio>
            <el-radio :label="1">男</el-radio>
            <el-radio :label="0">女</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="是否到店" prop="isgoto">
          <el-radio-group v-model="infoForm.isgoto">
            <el-radio :label="0">未到店</el-radio>
            <el-radio :label="1">已到店</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item v-if="infoForm.isgoto === 1" label="到店时间" prop="gototime">
          <el-date-picker
            v-model="infoForm.gototime"
            value-format="yyyy-MM-dd"
            type="date"
            placeholder="选择到店时间"
          />
        </el-form-item>
        <el-form-item label="地区" prop="city">
          <el-cascader
            v-model="infoForm.city"
            style="width:100%"
            :options="cityoptions"
            filterable
          />
        </el-form-item>
        <el-form-item label="详细地址" prop="address">
          <el-input v-model="infoForm.address" type="textarea" maxlength="200" />
        </el-form-item>
        <el-form-item label="意向风格" prop="style">
          <el-select v-model="infoForm.style" filterable clearable>
            <el-option v-for="style in styleList" :key="style.sid" :label="style.name" :value="style.name" />
          </el-select>
        </el-form-item>
        <el-form-item label="房屋面积" prop="area" style="width: 300px;">
          <el-input v-model="infoForm.area">
            <template slot="append">m²</template>
          </el-input>
        </el-form-item>
        <el-form-item label="分组" prop="groupid">
          <el-select v-model="infoForm.groupid" filterable :clearable="true">
            <el-option
              v-for="gitem in groupoptions"
              :key="gitem.value"
              :label="gitem.label"
              :value="gitem.value"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="标签" prop="labels">
          <el-checkbox-group v-model="infoForm.labels" :max="3">
            <el-checkbox v-for="titem in tagaoption" :label="titem.tagid" name="labels">{{ titem.name }}</el-checkbox>
          </el-checkbox-group>
          <el-button size="small" icon="el-icon-edit" type="text" @click="tagsDrawer = true">标签管理...</el-button>
        </el-form-item>
        <el-form-item label="备注" prop="remark">
          <el-input v-model="infoForm.remark" type="textarea" maxlength="200" />
        </el-form-item>
        <el-form-item style="text-align: right;">
          <el-button type="primary" :loading="editloading" @click="subClientInfo('infoForm')">立即提交</el-button>
          <el-button @click="dialogVisible=false">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <el-drawer
      title="标签管理"
      :visible.sync="tagsDrawer"
      direction="rtl"
    >
      <div class="tags-container">
        <el-row>
          <div v-for="t in tagaoption" class="tags-item">
            <span>{{ t.name }}</span>
            <el-button v-if="t.userid != 0" type="danger" class="tags-del" icon="el-icon-close" circle @click="delTags(t.tagid)" />
          </div>
          <el-button size="small" icon="el-icon-plus" type="primary" plain @click="addTags">添加</el-button>
        </el-row>
      </div>
    </el-drawer>
  </div>
</template>

<script>
import { getUser } from '@/utils/auth'
import { getDelClientGroupList, editDelClientGroup, delDelClientGroup, getDelClientList, getDelClientTagList, editDelClientTag, delDelClientTag, editDelClientInfo } from '@/api/dealer'
import { getCity } from '@/utils/city'
import { validatePhoneNumber } from '@/utils/validate'
import { getStyleList, getWxStyleList } from '@/api/pub'
import { getDealerDetail } from '@/api/work'
export default {
  name: 'delkhlb',
  data() {
    const validateTel = (rule, value, callback) => {
      if (!validatePhoneNumber(value)) {
        callback(new Error('请输入正确的联系电话'))
      } else {
        callback()
      }
    }
    return {
      bid: 0,
      groupDrawer: false,
      tagsDrawer: false,
      search: '',
      groupOptions: [],
      groupoptions: [],
      groupid: 1,
      loading: false,
      tableData: [],
      currentPage: 1,
      pageSize: 20,
      total: 0,
      dialogVisible: false,
      editloading: false,
      cityoptions: getCity(),
      tagaoption: [],
      styleList: [],
      infoForm: {
        name: '',
        tel: '',
        weixin: '',
        sex: null,
        city: [],
        address: '',
        style: '',
        area: '',
        labels: [],
        groupid: null,
        remark: '',
        gototime: '',
        isgoto: null
      },
      infoRules: {
        name: [{ required: true, message: '请输入客户真实姓名', trigger: 'blur' }],
        tel: [{ required: true, trigger: 'blur', validator: validateTel }],
        sex: [{ required: true, message: '请选择性别', trigger: 'change' }],
        isgoto: [{ required: true, message: '请选择是否到店', trigger: 'change' }],
        gototime: [{ required: true, message: '请选择到店时间', trigger: 'blur' }]
      }
    }
  },
  computed: {
    user: getUser
  },
  created() {
    this.getDelClientGroupList()
    this.getData()
    this.getDelClientTagList()
    this.getBrandList()
  },
  methods: {
    getBrandList() {
      getDealerDetail({ delid: this.user.delid }).then(response => {
        if (response.data.brandlst.length > 0) {
          this.bid = response.data.brandlst[0].bid
          this.getStyleList()
        }
      })
    },
    getStyleList() {
      getWxStyleList({}).then(response => {
        let _styleList = []
        for (const s of response.data) {
          if (s.bid === this.bid) {
            _styleList.push(s)
          }
        }
        this.styleList = _styleList
      })
    },
    getDelClientGroupList() {
      getDelClientGroupList({ userid: this.user.userid }).then(response => {
        this.groupOptions = response.data
        const group = []
        for (const g of response.data) {
          if (g.groupid > 3) {
            group.push({ value: g.groupid, label: g.name })
          }
        }
        this.groupoptions = group
      })
    },
    addGroup() {
      this.$prompt('请输入分组名称', '添加分组', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        inputPattern: /\S/,
        inputErrorMessage: '分组名称不可为空'
      }).then(({ value }) => {
        editDelClientGroup({ userid: this.user.userid, groupid: 0, name: value }).then(response => {
          this.getDelClientGroupList()
        }).catch(() => {})
      }).catch(() => {})
    },
    delGroup(groupid) {
      this.$confirm('此操作将永久删除此分组, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        delDelClientGroup({ groupid: groupid }).then(response => {
          this.getDelClientGroupList()
        }).catch(() => {})
      }).catch(() => {})
    },
    getDelClientTagList() {
      getDelClientTagList({ userid: this.user.userid }).then(response => {
        this.tagaoption = response.data
      }).catch(() => {})
    },
    addTags() {
      this.$prompt('请输入标签名称', '添加标签', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        inputPattern: /\S/,
        inputErrorMessage: '标签名称不可为空'
      }).then(({ value }) => {
        editDelClientTag({ userid: this.user.userid, tagid: 0, name: value }).then(response => {
          this.getDelClientTagList()
        }).catch(() => {})
      }).catch(() => {})
    },
    delTags(tagid) {
      this.$confirm('此操作将永久删除此标签, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        delDelClientTag({ tagid: tagid }).then(response => {
          this.infoForm.labels = []
          this.getDelClientTagList()
        }).catch(() => {})
      }).catch(() => {})
    },
    change(n) {
      if (this.groupid === n) {
        return false
      }
      this.groupid = n
      this.getData()
    },
    Search() {
      if (this.search != null && this.search.trim() !== '') {
        this.currentPage = 1
        this.getData()
      } else {
        this.search = ''
        this.getData()
      }
    },
    getData() {
      this.loading = true
      const data = {
        groupid: this.groupid,
        search: this.search,
        page: this.currentPage,
        limit: this.pageSize,
        delid: this.user.delid,
        userid: this.user.userid,
        islb: 1
      }
      getDelClientList(data).then(response => {
        this.loading = false
        this.tableData = response.data
        this.total = response.total
      }).catch(() => {
        this.loading = false
      })
    },
    handleSizeChange(val) {
      this.pageSize = val
      this.getData()
    },
    handleCurrentChange(val) {
      this.currentPage = val
      this.getData()
    },
    addClient() {
      this.dialogVisible = true
      this.infoForm.name = ''
      this.infoForm.tel = ''
      this.infoForm.weixin = ''
      this.infoForm.sex = null
      this.infoForm.city = []
      this.infoForm.address = ''
      this.infoForm.area = ''
      this.infoForm.style = ''
      this.infoForm.groupid = null
      this.infoForm.remark = ''
      this.infoForm.labels = []
      this.infoForm.isgoto = null
      this.infoForm.gototime = ''
    },
    subClientInfo() {
      this.$refs['infoForm'].validate((valid) => {
        if (valid) {
          if (!this.editloading) {
            this.editloading = true
            const data = {
              cid: 0,
              name: this.infoForm.name,
              tel: this.infoForm.tel,
              wchat: this.infoForm.weixin,
              sex: this.infoForm.sex,
              province: this.infoForm.city[0],
              city: this.infoForm.city[1],
              county: this.infoForm.city[2],
              address: this.infoForm.address,
              area: this.infoForm.area,
              style: this.infoForm.style,
              groupid: this.infoForm.groupid,
              remark: this.infoForm.remark,
              delid: this.user.delid,
              label: this.infoForm.labels.join(','),
              userid: this.user.userid,
              isgoto: this.infoForm.isgoto,
              gototime: this.infoForm.gototime
            }
            editDelClientInfo(data).then(response => {
              this.$message({
                message: '客户信息添加成功',
                type: 'success'
              })
              this.dialogVisible = false
              this.editloading = false
              this.getData()
            }).catch(() => {
              this.editloading = false
            })
          } else {
            return false
          }
        } else {
          return false
        }
      })
    },
    openDetails(row) {
      this.$router.push({ path: '/work/delclient/' + row.cid })
    }
  }
}
</script>

<style lang="scss" scoped>
  .khlb-container{
    .group-container{
      width: 100%;
      position: relative;
      padding: 20px;
      .group-item{
        position: relative;
        padding: 9px 15px;
        background: #FFF;
        border: 1px dashed #DCDFE6;
        border-radius: 4px;
        display: inline-block;
        color: #606266;
        font-size: 12px;
        font-weight: 500;
        margin:0 20px 20px 0;
        .group-del{
          padding: 2px!important;
          font-size: 10px!important;
          position: absolute;
          right: -10px;
          top: -6px;
        }
      }
    }
    .tcf-row{
      .card{
        .card-body{
          .card-title{
            .search-mode{
              width: 430px;
              position: relative;
              float: right;
              margin-top: -10px;
              padding-right: 130px;
              .search-input{
                background-color: #F2F6FC;
                border:0;
                height: 40px;
                line-height: 40px;
                border-radius: 4px;
                color: #606266;
                padding: 0 40px 0 15px;
                -webkit-appearance: none;
                font-size: 12px;
                width: 100%;
                -webkit-box-sizing: border-box;
                box-sizing: border-box;
                outline: 0;
                &::-webkit-input-placeholder {
                  color: #C0C4CC;
                }
                &::-ms-input-placeholder {
                  color: #C0C4CC;
                }
              }
              .search-btn{
                position: absolute;
                right: 130px;
                height: 40px;
                width: 40px;
                line-height: 40px;
                top: 0;
                border: 0;
                background: transparent;
                text-align: center;
                padding: 0;
              }
              .add-btn{
                position: absolute;
                right: 0;
              }
            }
          }
          .card-content{
            .group-filter{
              width: 100%;
              padding: 0 30px 0 0 ;
              margin: 0 ;
              position: relative;
              li{
                width: 100%;
                list-style: none;
                position: relative;
                padding-left: 20px;
                padding-top: 15px;
                padding-bottom: 15px;
                cursor: pointer;
                border-radius: 2px;
                text-overflow: ellipsis;
                overflow: hidden;
                white-space: nowrap;
                &.active{
                  background: #f5f7fa;
                  color:#409EFF;
                }
                &:hover{
                  color:#409EFF;
                }
              }
            }
            .client-sex{
              width: 16px!important;
              height: 16px!important;
              vertical-align: -4px!important;
            }
            .el-table::before{
              height: 0!important;
            }
            .el-pagination{
              margin-top: 20px;
            }
          }
        }
      }
    }
    .tags-container{
      width: 100%;
      position: relative;
      padding: 20px;
      .tags-item{
        position: relative;
        padding: 9px 15px;
        background: #FFF;
        border: 1px dashed #DCDFE6;
        border-radius: 4px;
        display: inline-block;
        color: #606266;
        font-size: 12px;
        font-weight: 500;
        margin:0 20px 20px 0;
        .tags-del{
          padding: 2px!important;
          font-size: 10px!important;
          position: absolute;
          right: -10px;
          top: -6px;
        }
      }
    }
  }
</style>
